import { useEffect } from 'react';
import { X, MessageSquare } from 'lucide-react';

interface ToastProps {
  id: string;
  title: string;
  message: string;
  userName: string;
  userId: string;
  onClose: (id: string) => void;
  duration?: number;
}

export default function Toast({ id, title, message, userName, userId, onClose, duration = 10000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const handleClick = () => {
    window.location.href = `/usuarios/${userId}`;
    onClose(id);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 mb-3 min-w-[320px] max-w-[400px] cursor-pointer hover:shadow-xl transition-all transform hover:scale-105 animate-slide-in"
      onClick={handleClick}
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
            <MessageSquare className="w-5 h-5 text-blue-600" />
          </div>
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <p className="text-sm font-semibold text-gray-900 truncate">
              {title}
            </p>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClose(id);
              }}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          
          <p className="text-xs text-gray-600 mb-2">
            {userName}
          </p>
          
          <p className="text-sm text-gray-700 line-clamp-2">
            {message}
          </p>
        </div>
      </div>
      
      {/* Progress bar */}
      <div className="mt-3 h-1 bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-blue-600 animate-progress"
          style={{ animationDuration: `${duration}ms` }}
        />
      </div>
    </div>
  );
}
